import { component } from 'picoapp';
import './style.scss';
import { getClosest } from '../../../utilities';

class Tabs {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.init(el);
  }

  init(el) {
    this.el = el;
    try {
      this.tabs = el.querySelectorAll('.Tabs__nav .Tabs__tab');
      this.panesContainer = el.querySelector('.Tabs__content');
      this.panes = this.panesContainer.querySelectorAll('.Tabs__pane');
      this.tabs.forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle(getClosest(e.target, '.Tabs__tab'));
        });
      });
      // Enable first tab if none is active when first loaded
      if (!this.el.querySelector('.Tabs__nav .is-active')) {
        this.enableTab(0);
      }
    } catch (error) {
      console.log(error);
    }
  }

  toggle(target) {
    let selectedTabIndex = Array.prototype.indexOf.call(this.tabs, target);
    let previousTabIndex = Array.prototype.indexOf.call(this.tabs, this.el.querySelector('.Tabs__tab.is-active'));

    this.tabs.forEach((el) => {
      el.classList.remove('is-active');
    });
    this.panes.forEach((el) => {
      el.classList.remove('is-active');
    });

    this.enableTab(selectedTabIndex, previousTabIndex);
  }

  enableTab(nextTab, previousTab) {
    if (previousTab >= 0) {
      this.panes[previousTab].classList.remove('is-active');
      this.tabs[previousTab].classList.remove('is-active');
    }
    this.panes[nextTab].classList.add('is-active');
    this.tabs[nextTab].classList.add('is-active');
    this.ctx.emit('openTab', { 'tab': this.el });
  }
}

export default component((node, ctx) => {
  new Tabs(node, ctx);
});
